import { secretKey } from '../../Enum/SecretKey';

var CryptoJS = require("crypto-js");
export const decrypt = data => {
  var bytes = CryptoJS.AES.decrypt(data, secretKey);
  var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

  return decryptedData;
};
